import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {RouterOutlet} from "@angular/router";
import {RoutingModule} from "./app.routing";
import {LoginComponent} from "./landing/login/login.component";
import {SharedModule} from "./shared/modules/shared.module";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {TokenInterceptor} from "./core/interceptors/token.interceptor";
import {LoginConfirmationComponent} from "./landing/login-confirmation/login-confirmation.component";
import { WelcomeModalComponent } from './shared/modals/welcome-modal/welcome-modal.component';
import {AvatarGuard} from "./core/guards/avatar.guard";
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { CustomAlertModalComponent } from './shared/modals/custom-alert-modal/custom-alert-modal.component';
import {MarkdownModule} from "ngx-markdown";
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from "@angular/material/button-toggle";

registerLocaleData(en);

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        LoginConfirmationComponent,
        WelcomeModalComponent,
        CustomAlertModalComponent,
    ],
    exports: [],
    bootstrap: [AppComponent], imports: [BrowserModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        RouterOutlet,
        RoutingModule,
        SharedModule,
        FormsModule,
        MarkdownModule.forRoot()], providers: [
        AvatarGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        { provide: LOCALE_ID, useValue: 'it' },
        {
            // M3 riserva spazio per un indicatore di selezione nei button-toggle:
            // lo nascondiamo per mantenere l'aspetto pre-Angular 22 (selezione = solo sfondo).
            provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
            useValue: { hideSingleSelectionIndicator: true, hideMultipleSelectionIndicator: true }
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
